<template>
  <div class="forgotPassword-main background_color">
    <v-row
      style="width: 100% !important; height: 100vh"
      justify="center"
      align-content="center"
    >
      <v-col cols="5">
        <v-card class="py-12">
          <v-card-title class="d-flex justify-center mb-7">
            <img :src="$globalConstant.logo" contain style="max-height: 50px" />
          </v-card-title>
          <v-form
            v-model="isValid"
            ref="forgotPasswordForm"
            @submit.prevent="verifyOtp"
          >
            <v-card-text>
              <v-stepper v-model="forgotPasswordSteps" verticle elevation="0">
                <v-stepper-step :complete="forgotPasswordSteps > 1" step="1">
                  Enter Username
                </v-stepper-step>
                <v-stepper-content step="1">
                  <v-row no-gutters class="mb-8">
                    <v-col class="pa-1">
                      <InputField
                        v-model.trim="userDetails.username"
                        prepend-inner-icon="mdi-account-circle"
                        name="username"
                        label="Username"
                        type="text"
                        :rules="[(v) => !!v || 'Username is required']"
                        :error-messages="formError.username"
                        @input="delete formError.username"
                      ></InputField>
                    </v-col>
                  </v-row>

                  <v-btn
                    :disabled="!userDetails.username"
                    color="primary"
                    @click="validateUsername()"
                  >
                    Next
                  </v-btn>
                </v-stepper-content>

                <v-stepper-step
                  :complete="forgotPasswordSteps > 2"
                  step="2"
                  class=""
                >
                  <span>Configure Credentials</span>
                </v-stepper-step>
                <v-stepper-content step="2">
                  <v-row no-gutters class="mb-8">
                    <v-col cols="12" class="d-flex justify-end pb-4">
                      <v-btn
                        :disabled="alreadySent"
                        color="primary"
                        depressed
                        @click="validateUsername()"
                      >
                        <countdown
                          :time="900000"
                          :transform="transform"
                          v-if="alreadySent"
                          v-slot="{ seconds, totalMinutes }"
                          @end="alreadySent = false"
                          >Resend in - {{ totalMinutes }} : {{ seconds }}
                        </countdown>
                        <span v-else>Resend</span>
                      </v-btn>
                    </v-col>
                    <v-col cols="12" class="input-override">
                      <v-otp-input
                        v-model.trim="userDetails.otp"
                        length="6"
                        background-color="background_color"
                        type="number"
                      ></v-otp-input>
                    </v-col>
                    <v-col cols="12" class="mt-4">
                      <PasswordField
                        label="new password"
                        name="password"
                        prepend-inner-icon="mdi-lock-outline"
                        v-model="userDetails.password"
                        :rules="[(v) => !!v || 'Password is required']"
                        :error-messages="formError.password"
                        @input="delete formError.password"
                      />
                    </v-col>
                    <v-col cols="12" class="mt-6">
                      <PasswordField
                        label="Confirm new password"
                        name="confirm_password"
                        prepend-inner-icon="mdi-lock-outline"
                        v-model="userDetails.confirm_password"
                        :rules="[
                          (v) =>
                            !v ||
                            v == userDetails.password ||
                            `Password does not match`,
                        ]"
                        :error-messages="formError.confirm_password"
                        @input="delete formError.confirm_password"
                      />
                    </v-col>
                  </v-row>
                  <v-btn
                    color="primary"
                    depressed
                    @click="verifyOtp()"
                    :disabled="!isValid || otpLimitExceeded"
                  >
                    Submit
                  </v-btn>
                </v-stepper-content>
              </v-stepper>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { bus } from "@/main.js";

export default {
  name: "adminLogin",
  data() {
    return {
      userDetails: {},
      isValid: true,
      formError: {},

      forgotPasswordSteps: 1,
      alreadySent: false,
      otpLimitExceeded: false,
    };
  },
  computed: {},
  methods: {
    transform(props) {
      Object.entries(props).forEach(([key, value]) => {
        // Adds leading zero
        const digits = value < 10 ? `0${value}` : value;

        props[key] = `${digits}`;
      });

      return props;
    },
    validateUsername() {
      bus.$emit("showLoader", true);
      this.$api.authentication
        .resetPassword({ username: this.userDetails.username })
        .then(({ data }) => {
          if (data) {
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: data.message,
              color: "success",
            });
            this.forgotPasswordSteps = 2;
            this.alreadySent = true;
          }
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          this.formError = err.data;
        });
    },
    verifyOtp() {
      bus.$emit("showLoader", true);
      let payload = {
        username: this.userDetails.username,
        verification_code: this.userDetails.otp,
        new_password: this.userDetails.password,
      };
      this.$api.authentication
        .verifyOtp(payload)
        .then(({ data }) => {
          if (data) {
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: "Password changed successfully",
              color: "success",
            });
            this.$router.push({ name: "login" });
          }
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          if (err.data) {
            this.formError = err.data;
            if (this.formError.verification_code) {
              bus.$emit("showToastMessage", {
                message: this.formError.verification_code.join(),
                color: "error",
              });
            }
            if (this.formError.non_field_errors) {
              this.formError.non_field_errors.forEach((error) => {
                this.otpLimitExceeded = true;
                bus.$emit("showToastMessage", {
                  message: error,
                  color: "error",
                });
              });
            }
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.forgotPassword-main {
  overflow: hidden;
  height: 100vh;
}
@media screen and (max-width: 768px) {
  .forgotPassword-main {
    display: flex;
    align-items: flex-end;
    height: 100vh;
  }
}
</style>
